import Arrow from "@/public/assets/images/arrow-circle-left.svg";
import { useSwiper } from "swiper/react";

const SwiperTestimonialsButtons = () => {
  const swiper = useSwiper();
  return (
    <div className="testimonials__buttons">
      <button
        className="button"
        onClick={() => {
          swiper.slidePrev();
        }}
      >
        <Arrow />
      </button>
      <button
        className="button"
        onClick={() => {
          swiper.slideNext();
        }}
      >
        <Arrow />
      </button>
    </div>
  );
};

export default SwiperTestimonialsButtons;
